import React, { SetStateAction } from "react";
import { Box, Button, Link, Typography } from "@mui/material";
import { HeadingSubHeadingStyles } from "./HeadingSubHeadingStyles";
import { borderRadius, SxProps, Theme } from "@mui/system";
import { Dispatch } from "@reduxjs/toolkit";
import { useTheme } from "@mui/material/styles";

interface HeadingSubHeadingProps {
  heading: string | number;
  subheading: string;
  headingAdditionalClassName?: SxProps<Theme>;
  subHeadingAdditionalClassName?: SxProps<Theme>;
  containerAdditionalClassName?: SxProps<Theme>;
  percentage?: boolean;
  statusCode?: string;
  customerCard?: boolean;
  setStatusCode?: Dispatch<SetStateAction<any>>;
  setContinuationId?: Dispatch<SetStateAction<any>>;
  setPrevId?: Dispatch<SetStateAction<any>>;
}

const HeadingSubHeading: React.FC<HeadingSubHeadingProps> = ({
  heading,
  subheading,
  headingAdditionalClassName,
  subHeadingAdditionalClassName,
  containerAdditionalClassName,
  percentage = false,
  customerCard,
  setStatusCode,
  setContinuationId,
  setPrevId,
  statusCode,
  ...rest
}) => {
  const theme = useTheme();
  const handleMetricsStatusFilter = (status: string) => {
    if (status === "Total" || status === undefined) return;
    if (status !== undefined) {
      setContinuationId && setContinuationId(null);
      setPrevId && setPrevId(null);
      if (setStatusCode) {
        setStatusCode(subheading);
      }
    }
    if (setContinuationId) {
      setContinuationId(null);
    }
    if (setPrevId) {
      setPrevId(null);
    }
  };
  return (
    <Box
      sx={Object.assign(
        {},
        HeadingSubHeadingStyles.container,
        containerAdditionalClassName,
        {
          border:
            statusCode === subheading ||
            (!statusCode && subheading === "Active" && !customerCard)
              ? "1px solid var(--shaded-cyan)"
              : "none",
          borderRadius:
            statusCode === subheading ||
            (!statusCode && subheading === "Active" && !customerCard)
              ? "10px"
              : "none",
          paddingX:
            statusCode === subheading ||
            (!statusCode && subheading === "Active" && !customerCard)
              ? 1
              : "none",
        }
      )}
    >
      <Typography
        sx={Object.assign(
          {},
          HeadingSubHeadingStyles.heading,
          headingAdditionalClassName,
          {
            color:
              statusCode === subheading ||
              (!statusCode && subheading === "Active" && !customerCard)
                ? theme.palette.primary.main
                : theme.palette.secondary.main,
          }
        )}
      >
        {heading}
        {percentage && (
          <Box component="span" sx={HeadingSubHeadingStyles.percentage}>
            %
          </Box>
        )}
      </Typography>
      <Typography
        id={`${subheading}-button`}
        data-test-id={`test-${subheading}`}
        aria-label={`${subheading}`}
        onClick={() => handleMetricsStatusFilter(subheading)}
        sx={Object.assign(
          {},
          HeadingSubHeadingStyles.subheading,
          subHeadingAdditionalClassName,
          {
            color:
              statusCode === subheading ||
              (!statusCode && subheading === "Active" && !customerCard)
                ? theme.palette.primary.main
                : theme.palette.secondary.main,
            textDecoration: "none",
            cursor:
              subheading === "Total" || customerCard
                ? "default"
                : subheading === undefined
                ? "default"
                : "pointer",
            "&:hover": {
              textDecoration:
                subheading === "Total" || customerCard
                  ? "none"
                  : subheading === undefined
                  ? "none"
                  : "underline",
            },
          }
        )}
      >
        {subheading}
      </Typography>
    </Box>
  );
};

export default HeadingSubHeading;
